import React, { useEffect, useState } from 'react';

const FeedbackHighlightsWidget = () => {
  const [highlights, setHighlights] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchHighlights = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/dashboard/feedback-highlights`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
            'Content-Type': 'application/json',
          },
        });

        if (!res.ok) throw new Error('Failed to fetch feedback highlights');

        const data = await res.json();
        setHighlights(data.highlights || []);
      } catch (err) {
        console.error('Error loading highlights:', err);
        setHighlights(['Unable to load highlights.']);
      } finally {
        setLoading(false);
      }
    };

    fetchHighlights();
  }, []);

  return (
    <div className="relative bg-gray-100 shadow-inner rounded-lg p-6 overflow-hidden">
      {/* Background pattern */}
      <span
        aria-hidden="true"
        style={{
          backgroundImage: "url('/patterns/bubbles.svg')",
          backgroundSize: "150%",
          opacity: 0.1,
        }}
        className="pointer-events-none absolute inset-0 bg-repeat z-0"
      />
  
      {/* Foreground content */}
      <div className="relative z-10">
        <h2 className="text-2xl font-bold text-gray-800 text-center mb-6">AI Feedback Highlights</h2>
  
        {loading ? (
          <div className="flex items-center justify-center h-32">
            <p className="text-sm text-gray-500 animate-pulse">Loading highlights...</p>
          </div>
        ) : highlights.length ? (
          <ul className="space-y-3">
            {highlights.map((line, idx) => (
              <li key={idx} className="bg-gradient-to-r from-blue-100 via-purple-100 to-pink-100 shadow-md rounded-lg p-4 text-base text-gray-700 border-l-4 border-blue-500">
                {line}
              </li>
            ))}
          </ul>
        ) : (
          <div className="flex items-center justify-center h-32">
            <p className="text-sm text-gray-500">No highlights available yet.</p>
          </div>
        )}
      </div>
    </div>
  );
  
};

export default FeedbackHighlightsWidget;
